import type {
  StripeElements as BaseStripeElements,
  StripeElementsUpdateOptions as BaseStripeElementsUpdateOptions,
} from "@stripe/stripe-js";

// Elements
// ==============================================

export const stripeElementsModes = {
  setup: "setup",
  payment: "payment",
  subscription: "subscription",
} as const;
export type StripeElementsMode = keyof typeof stripeElementsModes;

export const stripeElementsSetupFutureUsages = {
  off_session: "off_session",
  on_session: "on_session",
} as const;

// https://docs.stripe.com/js/elements_object/update
export interface StripeElementsUpdateOptions
  extends Omit<
    BaseStripeElementsUpdateOptions,
    "customerSessionClientSecret" | "payment_method_types"
  > {
  // stripe.js types does not allow `customerSessionClientSecret` to be `null`
  customerSessionClientSecret?: string | null;
  // stripe.js types does not include the `payment_method_configuration` parameter
  payment_method_configuration?: string | null;
  // stripe.js types does not allow `payment_method_types` to be `null`
  payment_method_types?: string[] | null;
}

export interface StripeElements extends BaseStripeElements {
  // stripe.js types does not include the `off` method, we add it here to make it work
  off: (event: "update-end", listener: () => void) => void;

  // overrides 'update' method from stripe.js types to allow:
  // - Updating `customerSessionClientSecret` to `null`
  // - Updating `payment_method_configuration`
  // - Updating `payment_method_types` to `null`
  update: (options: StripeElementsUpdateOptions) => void;
}

// Payment Element
// ==============================================

export const stripeElementsPaymentElementLayoutTypes = {
  accordion: "accordion",
  tabs: "tabs",
} as const;

// Address Element
// ==============================================

export const stripeElementsAddressElementModes = {
  billing: "billing",
  shipping: "shipping",
} as const;
